var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "outer-navigation" }, [
    _c("div", { staticClass: "banner" }, [
      _c(
        "nav",
        { staticClass: "desktop" },
        _vm._l(_vm.navItems, function (item, itemIndex) {
          return _c(
            "a",
            {
              key: itemIndex,
              staticClass: "nav-link",
              class: { "nav-group": !!item.subnav },
              attrs: { href: "javascript:;" },
              on: {
                click: function ($event) {
                  item.subnav ? null : _vm.handleNavLinkClick(item)
                },
              },
            },
            [
              _vm._v("\n        " + _vm._s(item.text) + "\n        "),
              item.subnav
                ? [
                    _c("svg-icon", {
                      staticClass: "icon up",
                      attrs: { color: "red", name: "vectorup" },
                    }),
                    _vm._v(" "),
                    _c("svg-icon", {
                      staticClass: "icon down",
                      attrs: { color: "red", name: "vectordown" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown" },
                      _vm._l(item.subnav, function (subItem, subItemIndex) {
                        return _c("a", {
                          key: subItemIndex,
                          staticClass: "nav-link",
                          domProps: { textContent: _vm._s(subItem.text) },
                          on: {
                            click: function ($event) {
                              return _vm.handleNavLinkClick(subItem)
                            },
                          },
                        })
                      }),
                      0
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "banner-logo",
          attrs: {
            href: _vm.getCesUrl,
            target: "_blank",
            rel: "noreferrer noopenner",
          },
        },
        [
          _c("img", {
            staticClass: "banner-logo-desktop-pic",
            attrs: {
              src: require("@/assets/images/banner_desktop.png"),
              alt: "ces-official-exhibitor",
            },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "banner-logo-mobile-pic",
            attrs: {
              src: require("@/assets/images/banner_mobile.png"),
              alt: "ces-official-exhibitor",
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }